import { element, classifications } from '@/api/element';
import { handleError } from '@/actions/common';
import { ElementDetails } from '@bimdata/viewer-react';

async function item(projectId: string, elementId: number, accessToken?: string): Promise<ElementDetails> {
  try {
    const e = await element(projectId, elementId, accessToken);
    const classification = await classifications(projectId, { id: elementId }, accessToken);
    return { ...e, classification };
  } catch (error) {
    handleError(error);
    throw error;
  }
};

export {
  item
};